import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const darkOwlVision = defineConnector({
  identifier: "darkOwlVision",
  name: "DarkOwl Vision",
  tagLine: "Dark web threat intelligence",
  keywords: "darkowl search entity ransomware darksonar darkint score",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "^https://api\\.darkowl\\.com/.*",
  auth: customAuth("darkOwlVision"),
  steps: [
    {
      title: "Enter your DarkOwl Vision keys",
      items: [
        {
          kind: "markdown",
          content:
            "Contact DarkOwl Product Support to obtain your public and private API keys. Ensure your subscription includes the resources you need and your stack’s outbound IP addresses are approved by DarkOwl. See the [Vision API documentation](https://docs.api.darkowl.com/).",
        },
        {
          kind: "input",
          label: "Public key",
          required: true,
          target: { kind: "secrets", field: "publicKey" },
        },
        {
          kind: "input",
          label: "Private key",
          required: true,
          target: { kind: "secrets", field: "privateKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.darkowl.com/api/v1/test",
      expectedStatus: 200,
      expectedBodyContains: "hoot",
    }),
  },
  usageHint: () =>
    "Send requests to https://api.darkowl.com for Search, Entity, Ransomware, DarkSonar, and DARKINT Score resources. The connector signs each request with HMAC-SHA1 automatically; omit authentication headers and do not sign requests in step code.",
});
